<template>
  <div class="ima-app">
    <ima-messages></ima-messages>
    <ima-header class="ima-app_header" v-if="user.isLoggedIn "></ima-header>
    <div class="ima-app__container" :class="{'ima-app__container--white' : user.isLoggedIn}">
      <ima-navigation class="ima-app__navigation" v-if="user.isLoggedIn && hasInitialData"></ima-navigation>
     <span class="ima-app__version">
      {{versionString}}
    </span>
      <main class="ima-app__main" v-bind:class="{'ima-app__main--active': user.isLoggedIn}">
        <router-view class="ima-app__viewport" v-if="!user.isLoggedIn || (user.isLoggedIn && hasInitialData)"></router-view>
        <ima-preloader v-if="user.isLoggedIn && !hasInitialData" />
        <ima-footer class="ima-app__footer" v-if="user.isLoggedIn && hasInitialData"></ima-footer>
        <ima-modals v-if="user.isLoggedIn && hasInitialData"></ima-modals>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Messages from '@/components/Messages'
import Navigation from '@/components/Navigation'
import Preloader from '@/components/Preloader'
import Modals from '@/components/Modals'

export default {
  name: 'ima-app',
  components: {
    'ima-footer': Footer,
    'ima-header': Header,
    'ima-messages': Messages,
    'ima-navigation': Navigation,
    'ima-preloader': Preloader,
    'ima-modals': Modals
  },
  computed: {
    ...mapGetters(['isForcedPasswordChange']),
    ...mapState(['user', 'hasInitialData']),
    versionString () {
      return `v${__VERSION__}-b${__BUILD_NUMBER__}`
    }
  }
}
</script>

<style scoped lang="scss">
@import 'scss/settings';
.ima-app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100%;
  width: fit-content;

  &__header {
    position: relative;
  }

  &__container {
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    &--white {
      background-color: #fff;
    }
  }

  &__navigation {
  }

  &__version {
    color: #fff;
    width: $nav-width;
    position: fixed;
    bottom: 0;
    left: 0;
    font-size: 0.75rem;
    text-align: center;
  }

  &__main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: $main-padding;
    padding-bottom: $main-padding;

    &--active {
      background-color: #fff;
    }
  }

  &__viewport {
    flex-grow: 1;
  }

  &__footer {
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue